<template>
  <teleport to="body">
    <transition name="right">
      <div class="drawer" v-if="modelValue" v-bind="$attrs">
        <div class="drawer__header" v-if="title || $slots.header">
          <slot name="header">{{ title }}</slot>
          <v-icon class="drawer__close" @click="close">
            <X />
          </v-icon>
        </div>
        <div class="drawer__body">
          <slot></slot>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="mask" v-if="modelValue" @click="close"></div>
    </transition>
  </teleport>
</template>

<script setup>

import { onMounted, onUnmounted, watchEffect } from 'vue'
import { X } from 'lucide-vue-next'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'close'])
function close() {
  emit('update:modelValue', false)
  emit('close')
}

function keyEventHandler(event) {
  if (event.key == 'Escape') {
    close()
  }
}

watchEffect(() => {
  if (props.modelValue) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }
})

onMounted(() => {
  window.addEventListener('keyup', keyEventHandler)
})

onUnmounted(() => {
  window.removeEventListener('keyup', keyEventHandler)
})


</script>

<style scoped lang="scss">
.drawer {
  position: fixed;
  width: 70%;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 301;
  // background: #fff;
}

.drawer__header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  padding: 0 30px 0px 20px;
  border-bottom: 1px solid #e8e8e8;
  color: #72767b;
}

.drawer__close {
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.drawer__close:hover {
  color: var(--color-primary);
}

.drawer__body {
  height: calc(100vh);
  overflow-y: auto;
  overscroll-behavior-y: contain;
}
/* 动画 */
/* right */
.right-enter-active,
.right-leave-active {
  transition: all 0.3s ease;
}

.right-enter-from,
.right-leave-to {
  transform: translateX(100%);
}
/* 动画 */
/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.mask {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.42);
  z-index: 300;
}
</style>
